import React, { ComponentPropsWithRef, FC } from 'react';
import { Text } from '@components/Text/Text.component';
import { TextProps } from '@components/Text/Text.types';
import { AddressInfos } from '@utils/strings';
import classnames from 'classnames';
import styles from './Address.module.scss';

type Props = ComponentPropsWithRef<'address'> & {
  labelVariant?: TextProps['variant'];
  infoVariant?: TextProps['variant'];
  addressInfos?: AddressInfos;
  website?: string;
  email?: string;
  phone?: string;
};

export const Address: FC<Props> = ({
  labelVariant = 'h6',
  infoVariant = 'small',
  addressInfos,
  website,
  email,
  phone,
  className,
  ...rest
}) => {
  const rootClass = classnames(styles['plc-address'], className);
  return (
    <address className={rootClass} {...rest}>
      <dl>
        {addressInfos && (
          <>
            <dt>
              <Text i18nKey="events.info.address" tag="span" variant={labelVariant} />
            </dt>
            <dd className="plc-mb-s">
              <Text tag="span" variant={infoVariant}>
                <a href={addressInfos.link} rel="noopener noreferrer" target="_blank">
                  {addressInfos.address}
                </a>
              </Text>
            </dd>
          </>
        )}
        {website && (
          <>
            <dt>
              <Text i18nKey="events.info.website" tag="span" variant={labelVariant} />
            </dt>
            <dd className="plc-mb-s">
              <Text tag="span" variant={infoVariant}>
                <a href={website} rel="noopener noreferrer" target="_blank">
                  {website}
                </a>
              </Text>
            </dd>
          </>
        )}
        {email && (
          <>
            <dt>
              <Text i18nKey="events.info.email" tag="span" variant={labelVariant} />
            </dt>
            <dd className="plc-mb-s">
              <Text tag="span" variant={infoVariant}>
                <a href={`mailto:${email}`}>{email}</a>
              </Text>
            </dd>
          </>
        )}
        {phone && (
          <>
            <dt>
              <Text i18nKey="events.info.phone" tag="span" variant={labelVariant} />
            </dt>
            <dd className="plc-mb-s">
              <Text tag="span" variant={infoVariant}>
                <a href={`tel:${phone}`}>{phone}</a>
              </Text>
            </dd>
          </>
        )}
      </dl>
    </address>
  );
};
